export const BLOCK_EXPLORERS = {
	1: 'https://etherscan.io',
	4: 'https://rinkeby.etherscan.io',
	5: 'https://goerli.etherscan.io',
	56: 'https://bscscan.com',
	97: 'https://testnet.bscscan.com',
	80001: 'https://mumbai.polygonscan.com',
	137: 'https://polygonscan.com',
};
